<template>
    <div :style="{ backgroundColor: isExpert ? '#000E22' : '' }">
        <MercenaryHeader :isExpert="isExpert" :isBlur="true" :title="'전문가 등록 정보'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div :style="{ backgroundColor: !isExpert ? '#f5f5f5' : '' }" style="flex:1; padding:0px 12px; padding-top:40px;">
            <div v-if="isExpert">
                <div style="width: 310px; background: #86AFFF4D; border-radius: 20px; padding: 20px; margin: 0 auto; display: flex; flex-direction: column; align-items: center;">
                    <div style="font-weight: 700; font-size: 24px; line-height: 28px; color: #8ca2c9;">CERTIFICATED</div>
                    <div style="font-weight: 700; font-size: 12px; line-height: 14px; color: #d7e5ff;">사커하우 전문가 인증 완료</div>
                    <div style="margin-top: 20px; margin-bottom: 20px;">
                        <img style="width: 100px;" :src="require('@/assets/img/certificated.png')" alt="">
                    </div>
                    <div style="text-align: center; font-weight: 700; font-size: 12px; line-height: 14px; color: #8caae1;">위 사람은 축구 전문가로서<br>사커하우의 전문가 회원 자격이 있음을 알립니다.</div>
                    <div style="margin-top: 8px; font-weight: 700; font-size: 11px; line-height: 13px; color: #8caae1;">{{$Util.getYYYMMDDHangulStr(coach_applied_date)}}</div>
                </div>
                <div style="width: 310px; background: #86AFFF4D; border-radius: 20px; padding: 20px; margin: 0 auto; justify-content: space-between; margin-top: 20px; display: flex; flex-direction: column; align-items: center;">
                    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                        <div style="font-weight: 700; color: #fff; font-size: 14px;">
                            <div style="line-height: 24px;">사용자 유형</div>
                            <div style="line-height: 24px; font-weight: 500;">전문가 회원</div>
                        </div>
                        <div>
                            <img v-if="memberDoc.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 21px;" :src="require('@/assets/img/blue_star.png')" alt="">
                            <img v-else style="width: 21px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div style="padding: 12px; border-radius: 12px; background-color: #fff;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">상태</div>
                    <div style="border-bottom: 1px solid #ebebeb; font-weight: 500; line-height: 24px; padding-bottom: 8px; font-size: 14px;">전문가 인증 안됨</div>
                    <div @click="expertRegister" style="margin-top: 8px; font-size: 14px; line-height: 24px; color: var(--color-main); font-weight: 500;">전문가 등록하기</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from "@/components/common/MercenaryHeader";
import { TEAM_TYPE } from "../../Constants";
export default {
    name: "ExpertInformation",
    components: { MercenaryHeader },
    props: {
        isExpert: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            settings: {
                home_pedometer_show: false,
            },
            coach_applied_date : '',
            memberDoc: {},
            TEAM_TYPE: TEAM_TYPE
        }
    },
    methods: {
        expertRegister() {
            this.$GlobalStore.addModal('CoachRegisterExplanation')
        },
        async getMyMemberDoc(){
            const res = await this.$Axios.get('/api/player_cert/member_doc/mine');
            this.coach_applied_date = res.data.member_doc.coach_applied_date;
            this.memberDoc = res.data.member_doc
        }
    },
    created() {
        this.getMyMemberDoc()
    }
}
</script>

<style scoped></style>